import React from 'react';
import type { CommandServices } from '@wix/cli-command-contract';
import { createCommand } from '@commander-js/extra-typings';
import { createI18nT } from '../i18n.js';
import { validateVersion } from './validations.js';

export const logsCommand = (services: CommandServices) => {
  const t = createI18nT();

  return createCommand('logs')
    .requiredOption(
      '--version <version>',
      t('logs_command_def.option.version'),
      validateVersion
    )
    .action(async (options, command) => {
      const { version } = options;

      const { renderCommand } = await import('./render-command.js');

      const { LogsCommand } = await import(
        '../components/LogsCommand/index.js'
      );
      await renderCommand(command, services, <LogsCommand version={version} />);
    });
};
